module.exports = __webpack_public_path__ + "img/mu-six.ab165c4f.jpg";